var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer h-full" },
    [
      _c("div", { staticClass: "shopInfo" }, [
        _c("p", [
          _c("span", [_vm._v("品牌：" + _vm._s(_vm.brandInfo.brandName))]),
          _c("span", [
            _vm._v("电话："),
            _vm.storeArea
              ? _c(
                  "span",
                  {
                    staticStyle: {
                      "margin-right": "10px",
                      "border-right": "1px solid #ccc",
                      "padding-right": "10px"
                    }
                  },
                  [_vm._v("+" + _vm._s(_vm.storeArea))]
                )
              : _vm._e(),
            _vm._v(_vm._s(_vm.brandInfo.customerHotline))
          ])
        ])
      ]),
      _vm.isAmend
        ? _c("div", { staticClass: "customer-order-amend-title" }, [
            _vm._v("\n    修改订单中 \n  ")
          ])
        : _vm._e(),
      _vm.visible
        ? [
            _c("cc-modifyUser", { on: { openOrderPage: _vm.openOrderPage } }),
            _c("cc-modifyOrderInfo", {
              ref: "refOrder",
              on: { openOrderPage: _vm.openOrderPage }
            }),
            _c("cc-modifyStoreList", {
              on: { openOrderPage: _vm.openOrderPage }
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46d54564", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46d54564","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pagesCache/customer/customerNew.vue
// module id = VYuP
// module chunks = 1 2